export default "__VITE_ASSET__DK_wMDUp__"